import {createFetchActions} from '../../services/createActions'
import {post} from '../../services/createAPICall'
import {getQuantBaseUrl} from '../../services/apiService'

export const GET_PREDICTED_CURVE_DETAILS = createFetchActions('GET_PREDICTED_CURVE_DETAILS')

export const getPredictedCurveDetails = req => (dispatch: any) => {
	return dispatch(post(GET_PREDICTED_CURVE_DETAILS, getQuantBaseUrl(), req))
}
